import {DocumentPart} from '@dv5/domain'
import {FC, useMemo} from 'react'
import './SecretViewer.less'

interface Props {
    part: DocumentPart
}

const MIN_ASTERISKS = 6
const MAX_ASTERISKS = 16

const getAsterisks = (): string => {
    const count = Math.floor(Math.random() * (MAX_ASTERISKS - MIN_ASTERISKS + 1)) + MIN_ASTERISKS
    return '*'.repeat(count)
}

export const SecretViewer: FC<Props> = ({part}) => {
    const asterisks = useMemo(() => getAsterisks(), [])

    return (
        <div className="secret-viewer">
            {asterisks}
        </div>
    )
}
